import React from 'react';
import RecoverableImage from '../features/images/RecoverableImage';
import ProfileIdentity from '../components/content/ProfileIdentity';
import baseline, { appTextStyle } from './baseline';
import './AppContent.css';

// One avatar beside one copy column. Metadata belongs in that column, never below the avatar.
export default function AppAuthor({ name = 'postpop', image, mark, metadata, featured = false }) {
  const { playlist, contentText } = baseline;
  const size = featured ? playlist.heroOwnerAvatar.width : 20;
  return (
    <span
      className="pp-app-author"
      style={{ gap: playlist.heroOwnerRow.gap, '--pp-mark-size': `${featured ? 14 : 12}px` }}
    >
      <span
        className="pp-app-author-avatar"
        aria-hidden="true"
        style={{
          ...appTextStyle(
            featured ? baseline.tokens.typography.bodyMedium : playlist.inlineOwnerInitial,
          ),
          width: size,
          height: size,
        }}
      >
        <span>{name.slice(0, 1)}</span>
        {image && <RecoverableImage src={image} alt="" loading="lazy" />}
      </span>
      <span className="pp-app-author-copy">
        <span className="pp-app-author-name" style={appTextStyle(contentText.author)}>
          <ProfileIdentity name={name} mark={mark} avatar={false} />
        </span>
        {metadata !== undefined && (
          <span className="pp-app-author-meta" style={appTextStyle(contentText.metadata)}>
            {metadata}
          </span>
        )}
      </span>
    </span>
  );
}
